export { default } from './PrivacyPolicy';
